import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

import {
  getContainingUrlFromActiveTab,
  isInExtension
} from '@mote/helpers/extension'
import {
  HasOptedOutOfTranscription,
  GetTranscriptionLanguage,
  ShowStemTranscript
} from 'plugin/src/shared/Settings'
import { getTZOffset } from 'plugin/src/shared/Utils'
import { getExtensionVersion } from '@mote/helpers/extension'
import { isMoteForSlidesActive } from 'plugin/src/widget/slides/helpers'
import { getBasicClassroomInfo } from 'plugin/src/shared/classroom/classroomInfo'

export const useMoteRegisterMutation = (
  parentMoteId = undefined,
  shouldRedirect = false
) => {
  const json = { containingURL: window.location.href, TZOffset: getTZOffset() }

  if (parentMoteId) {
    json.parentMoteId = parentMoteId
  }

  if (isInExtension()) {
    getContainingUrlFromActiveTab().then(
      url => (json.containingURL = url || window.location.href)
    )
    json.transcriptionOptOut = HasOptedOutOfTranscription()
    json.transcriptionLanguage = GetTranscriptionLanguage()
    json.showStemTranscript = ShowStemTranscript()
    json.clientVersion = `extension:${getExtensionVersion()}`
    json.googleSlidesInsertMode = isMoteForSlidesActive()
    json.shouldRedirect = shouldRedirect
    const classroomData = getBasicClassroomInfo()
    for (const classroomProperty in classroomData) {
      json[classroomProperty] = classroomData[classroomProperty]
    }
  }

  return useGenericRequestHandler({
    route: `v1/m/register`,
    method: 'POST',
    options: {
      json
    }
  })
}

export function moteRegistrationDataGetter(data) {
  return data?.moteStatus || data
}
